import script from "./CodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__